import React, { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import AuthPage from './components/AuthPage';
import UserDashboard from './components/UserDashboard';
import VideoGallery from './components/VideoGallery';
import AccountSettings from './components/AccountSettings';
import Subscription from './components/Subscription';
import ChatWidget from './components/ChatWidget';
import IntakeLandingPage from './components/IntakeLandingPage';
import PlanningLandingPage from './components/PlanningLandingPage';
import './App.css';

function AppContent() {
  const { user, loading } = useAuth();
  const [currentView, setCurrentView] = useState('intake'); // 'intake', 'planning', 'dashboard', 'videos', 'settings', 'subscription'

  // Check URL parameters on mount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const viewParam = urlParams.get('view');
    
    if (viewParam === 'planning') {
      setCurrentView('planning');
    }
  }, []);

  // Show planning page if requested
  if (currentView === 'planning') {
    return <PlanningLandingPage />;
  }

  // Show intake page first
  if (currentView === 'intake') {
    return <IntakeLandingPage onComplete={() => setCurrentView('dashboard')} />;
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-red-600 mx-auto mb-4"></div>
          <p className="text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <AuthPage />;
  }

  if (currentView === 'videos') {
    return (
      <VideoGallery 
        onBackToDashboard={() => setCurrentView('dashboard')}
        onViewSettings={() => setCurrentView('settings')}
        onViewSubscription={() => setCurrentView('subscription')}
      />
    );
  }

  if (currentView === 'settings') {
    return <AccountSettings onBack={() => setCurrentView('dashboard')} />;
  }

  if (currentView === 'subscription') {
    return <Subscription onBack={() => setCurrentView('dashboard')} />;
  }

  return (
    <UserDashboard 
      onViewVideos={() => setCurrentView('videos')}
      onViewSettings={() => setCurrentView('settings')}
      onViewSubscription={() => setCurrentView('subscription')}
    />
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
      <ChatWidget />
    </AuthProvider>
  );
}

export default App;

